import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'
import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Footer from '../../components/Footer/Footer';
import H2 from '../../collections/H2/H2';
import {media} from "../../utilities/style-utilities";

import { ScaleLoader } from 'react-spinners';
import { fontEdenredLight } from '../../utilities/utilities';
const queryString = require('query-string');

const TextBox = styled.div`
    padding:20px;
`;

const SuccessWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 964px;
  background-color: white;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 150px;
  z-index: 1;
  margin-top: ${ props => props.overlay === false ? '8rem' :  '16rem' };
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);

  ${ media.desktop`
    margin: 1rem;
  `}
`;

class VerifyEmailPage extends Component {
    state = {
        success: false,
        sessionExpired: false,
        newEmailAddress:''
    }

    componentDidMount() {
        let parsed= queryString.parse(this.props.location.search);
        this.props.api.veryfyEmailChange(parsed.u,parsed.t).then(response =>{

            const jsonResponse = JSON.parse(response);
            
            if (jsonResponse.meta.status === 'succeeded') {
                this.setState({
                    success: true,
                    newEmailAddress: jsonResponse.data
                })
            }
            else {
                this.setState({
                    sessionExpired: true
                })
            }
      }).catch(error => {
          this.setState({
              sessionExpired: true
          })
      })
    };

    render(){
        const iconStyles = {
            marginTop: '30px',
            fontSize: '50px',
            textAlign:'center',
        };

        const headerStyles = {
            textAlign:'center',
            fontSize: '30px',
            lineHeight: 'unset',
            fontFamily: fontEdenredLight,
        };
        if (this.state.success) return <Redirect to ={{pathname:"/emailverified", state: {email: this.state.newEmailAddress} }}/>

        if (this.state.sessionExpired) return <Redirect to="/sessionexpired" />

        return (
            <Fragment>
    
                <Helmet>
                    <title>{`Incentive Award Card`}</title>
                </Helmet>
    
                <Header header={this.props.appState.ui.header} url={this.props.url}/>
                <Main site={this.props.appState.ui.site} >
                    <SuccessWrapper>
                        <div style={iconStyles}>
                            <ScaleLoader color={'#0085ca'} />
                        </div>
                        <TextBox>
                            <H2 style={headerStyles}>...ongoing process</H2>
                        </TextBox>
                    </SuccessWrapper>
                </Main>
                <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms}/>
            </Fragment>
        );
    }
}

export default VerifyEmailPage;


// WEBPACK FOOTER //
// ./src/containers/VerifyEmailPage/VerifyEmailPage.js